import * as React from 'react';
import '../../../../../styles/WelcomePage.css';
import Button from '../../../../common/form/Button';
import ProspectHeader from '../../../../common/ProspectHeader';
import * as querystring from 'query-string';
import { browserHistory } from '../../../../../utilities/history';
import PropertySearchbar from './PropertySearchbar';
import { PropertyQuery } from './PropertyQuery';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';

const WelcomePage = () => {
    const [firstSuggestion, setFirstSuggestion] = useState<PropertyQuery>();

    const searchProperties = (searchValue: PropertyQuery) => {
        var queryString = querystring.stringify(searchValue);
        browserHistory.push({
            pathname: 'properties',
            search: queryString
        });
    };

    return (
        <div className="flex-root">
            <ProspectHeader />
            <div className={`splash-container ${isMobile ? 'mobile' : ''}`}>
                <div className="text">Self-Guided Tours</div>
                <div className="text tagline">Find your home on your own &#8482;</div>
            </div>
            <div className="splash-information">
                <div className="text-input-with-dropdown">
                    <PropertySearchbar
                        valueSelected={searchProperties}
                        setFirstSuggestion={setFirstSuggestion}
                    />
                </div>
                <Button
                    text="Search"
                    addlClassName="search-button"
                    disabled={!firstSuggestion}
                    onClick={() => firstSuggestion && searchProperties(firstSuggestion)}
                />
                <div>Always Open. Always Leasing. &#8482;</div>
            </div>
        </div>
    );
};

export default WelcomePage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/WelcomePage.tsx